import React, { Component } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import { searchInventoryTypes, searchItems } from "../../actions/records";
import DropDown from "../widgets/dropdown";
import Swal from "sweetalert2";
import { searchPackagingMaterials } from "../../actions/records";
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import colors from "../../constants/colors";
import { MaterialCommunityIcons } from "@expo/vector-icons";
var interval = null;
class SearchByProductCode extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.initial ? props.initial : "",
            supplierSelected: props.initial ? props.initial : "",
            height: 30,
            items: [],
            filteredSuppliers: [],
            wasEdited: false,
            openList: false,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.initial != this.props.initial) {
            this.setState({ value: nextProps.initial });
        }
        if (nextProps.closeSearch != this.props.closeSearch) {
            this.setState({ items: [], wasEdited: false });
        }
    }
    searchItems(val, type, focused) {
        const { onSelectItem, inventoryTypes } = this.props;
        if(interval)clearInterval(interval);
        if (val || focused) {
            switch (type) {
                case "rawMaterialProductCode":
                    var itemsData = { page: 1, productCode: val };
                    this.props.searchItems(itemsData, (res) => {
                        if (res?.items?.length > 0) {
                            this.setState({ items: res?.items });
                        } else {
                            this.setState({ items: [] });
                        }
                    });
                    break;
                case "packagingProductCode":
                    var itemsData = { page: 1, productCode: val };
                    this.props.searchPackagingMaterials(itemsData, (res) => {
                        if (res?.packagingMaterials?.length > 0) {
                            this.setState({ items: res?.packagingMaterials });
                        } else {
                            this.setState({ items: [] });
                        }
                    });
                    break;
                case "fgProductCode":
                    this.props.searchInventoryTypes({ page: 1, productCode: val, type: "Finished goods", fromApp: true }, (res) => {
                        if (res?.inventoryTypes?.length > 0) {
                            this.setState({ items: res.inventoryTypes });
                        } else {
                            this.setState({ items: [] });
                        }
                    });
                    break;
                case "wipProductCode":
                    this.props.searchInventoryTypes({ page: 1, productCode: val, type: "Work in progress", fromApp: true }, (res) => {
                        if (res?.inventoryTypes?.length > 0) {
                            this.setState({ items: res.inventoryTypes });
                        } else {
                            this.setState({ items: [] });
                        }
                    });
                    break;
            }
        } else {
            this.setState({ items: [] });
        }
        onSelectItem(val, null);
    }
    serchInInventoryTypes(value, type, inventoryTypes) {
        var types = inventoryTypes.filter(inventory => {
            if (inventory?.productCode) {
                var productCode = inventory.productCode.toLowerCase();
                return inventory.inventoryType == type && productCode.includes(value.toLowerCase());
            } else {
                return false;
            }
        });
        if (types.length > 10) {
            types = types.slice(0, 10);
        }
        return types;
    }
    alertConfirm(msg, conf) {
        Swal.fire({
            text: msg,
            confirmButtonText: conf,
            confirmButtonColor: '#0B4DA0',
            backdrop: false
        });
    }
    getItemName(item) {
        var name = item.itemName ? item.itemName : item.item ? item.item : item.namePackaging ? item.namePackaging : "";
        return name;
    }
    render() {
        const { value, items, wasEdited } = this.state;
        const { defaultComponent, onSelectItem, placeholder, customers, width, type, isShipmentLog, isInventoryTransfer } = this.props;
        return <View>
            <TextInput
                value={value}
                editable={!defaultComponent}
                onFocus={()=>{
                    this.searchItems("", type, true);
                }}
                onContentSizeChange={(event) => {
                    if (event.nativeEvent.contentSize.height == 0) {
                        if (this.props.placeholder == '') {
                            this.setState({ height: 30 })
                        }
                        this.setState({ height: event.nativeEvent.contentSize.height });
                    } else {
                        setTimeout(() => {
                            this.setState({ height: event.nativeEvent.contentSize.height });
                        }, 5)
                    }
                }}
                style={styles.input, {
                    borderColor: "#e7e7e7",
                    borderRadius: 5,
                    borderWidth: 1,
                    color: "#424242",
                    fontFamily: "Roboto",
                    fontSize: 20,
                    fontWeight: "400",
                    padding: 5,
                    height: this.state.height,
                    fontStyle: this.state.value ? this.state.value.length == 0 ? 'italic' : 'normal' : 'normal',
                    overflow: 'hidden'
                }}
                multiline={true}
                placeholder={placeholder}
                placeholderTextColor={'rgb(0, 47, 108)'}
                onChangeText={(val) => {
                    if (val == '' && this.props.placeholder == '') {
                        this.setState({ value: val, height: 30, wasEdited: true });

                    } else {
                        this.setState({ value: val, wasEdited: true });
                    }
                    if(interval)clearInterval(interval);
                    interval = setInterval(() => this.searchItems(val, type, false), 500);
                }}
            />
            {
                items?.length > 0 &&
                items.map((item, idx) => {
                    return <TouchableOpacity key={idx} style={{ ...styles.row, gridTemplateColumns: customers ? "95% 5%" : width == "mini" ? "80% 20%" : "90% 10%" }} onPress={() => {
                        if (isInventoryTransfer && item?.items?.length <= 0 && typeof item?.items == "object") {
                            this.alertConfirm(this.getItemName(item) + " does not have lot codes available to transfer.", "Accept");
                        } else {
                            if (isShipmentLog) {
                                var newItem = JSON.parse(JSON.stringify(item));
                                newItem.lotSelected = ["default_lot"];
                                onSelectItem(item?.productCode, newItem);
                                this.setState({ items: [], value: item?.productCode, wasEdited: false });
                            } else {
                                onSelectItem(item?.productCode, item)
                                this.setState({ items: [], value: item?.productCode, wasEdited: false });
                            }
                        }
                    }}>
                        <div style={{ wordBreak: 'break-all' }}>
                            {item?.productCode}
                        </div>
                        <div>
                            <div style={styles.rowBtn}><Text>
                                    <MaterialCommunityIcons name="plus" style={styles.selectOption} />
                                </Text>
                            </div>
                        </div>

                    </TouchableOpacity>
                })
            }
            {
                (value && items?.length <= 0 && wasEdited) ? <View>
                    <Text>No {'items'} were found</Text>
                </View> : null
            }

        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
    company_id: state.user.get("company_id"),
}), (dispatch, props) => ({
    searchItems: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchItems(formid, saveAsTemplate, saveAsForm, callback)),
    searchPackagingMaterials: (data, callback) =>
        dispatch(searchPackagingMaterials(data, callback)),
    searchInventoryTypes: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchInventoryTypes(formid, saveAsTemplate, saveAsForm, callback)),
}))(SearchByProductCode);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400",
        paddingLeft: 10,
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    row: {
        display: "grid",
        width: "100%",
        fontFamily: "Roboto",
        fontSize: 18
    },
    rowBtn: {
        color: 'rgb(244, 152, 30)',
        border: '2px solid',
        borderRadius: 4,
        cursor: 'pointer'
    },
    rowBtn: {
        color: colors.selectSearch,
        border: '2px solid',
        borderRadius: 4,
        cursor: 'pointer'
    },
    selectOption: {
        fontSize: 20,
        color: colors.selectSearch
    }
});